<template>
  <Multiselect
    :id="name"
    ref="searchInput"
    label="name"
    track-by="name"
    value-prop="code"
    :close-on-select="closeOnSelect"
    :create-tag="true"
    :mode="mode"
    :options="options"
    :placeholder="placeholder"
    :searchable="true"
    :show-options="showOptions"
    @paste="handlePaste"
    @search-change="handleSearch"
    @change="emit('change')"
  />
</template>

<script lang="ts" setup>
import { MultiSelectOption } from '@infuse/ui/domain';
import Multiselect from '@vueform/multiselect';
import { ref } from 'vue';

interface Props {
  closeOnSelect: boolean;
  mode?: 'multiple' | 'tags';
  name: string;
  options: MultiSelectOption[] | string[];
  placeholder?: string;
  pasteFunction?: (event: ClipboardEvent, instance: Multiselect) => void;
  handleSearchFunction?: (search: string, instance: Multiselect) => void;
  showOptions?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  closeOnSelect: true,
  mode: 'tags',
  name: 'multi-select',
  placeholder: '',
  pasteFunction: undefined,
  handleSearchFunction: undefined,
  showOptions: true
});

const emit = defineEmits(['change']);
const searchInput = ref();

const handlePaste = (event: Event, instance: Multiselect) => {
  if (props.pasteFunction) {
    props.pasteFunction(event as ClipboardEvent, instance);
  }
};

const handleSearch = (search: string, instance: Multiselect) => {
  if (props.handleSearchFunction) {
    props.handleSearchFunction(search, instance);
  }
};
</script>

<style>
@import '@vueform/multiselect/themes/tailwind.css';

/* This removes borders around the input element in the Multiselect. They look terrible. */
.multiselect-tags-search,
.multiselect-tags-search:focus {
  @apply border-none pl-0 focus:ring-0 focus:ring-offset-0;
}

.multiselect-tag {
  @apply bg-white border border-gray-800 text-gray-800 font-normal !important;
}
</style>
